import { Box, deprecatedPropType } from 'pcln-design-system';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
var HeaderBar = styled(Box).withConfig({
  displayName: "SmallModalHeader__HeaderBar",
  componentId: "sc-gmqrex-0"
})(["height:8px;"]);

var SmallModalHeader = function SmallModalHeader(_ref) {
  var bg = _ref.bg,
      color = _ref.color;
  return /*#__PURE__*/React.createElement(HeaderBar, {
    bg: bg,
    color: color
  });
};

SmallModalHeader.displayName = SmallModalHeader;
SmallModalHeader.propTypes = {
  bg: deprecatedPropType('color'),
  color: PropTypes.string
};
SmallModalHeader.defaultProps = {
  bg: 'green',
  color: 'secondary.base'
};
export default SmallModalHeader;